import createApiService from "../../http";
import {
  FETCH_DONATIONS,
  CREATE_DONATIONS,
  FETCH_DONATION_SUMMARY,
  FETCH_COUNTRY_SUMMARY,
  FETCH_DONATIONS_FROM_SHEET,
} from "./endpoints";

export const fetchDonationService = (params) =>
  createApiService({
    endpoint: FETCH_DONATIONS,
    method: "get",
    options: {
      params: {
        ...params,
      },
    },
  });

export const fetchDonationFromSheetService = (params) =>
  createApiService({
    endpoint: FETCH_DONATIONS_FROM_SHEET,
    method: "get",
    options: {
      params: {
        ...params,
      },
    },
  });

export const createDonationService = createApiService({
  method: "post",
  endpoint: CREATE_DONATIONS,
});

export const fetchDonationSummaryService = createApiService({
  method: "get",
  endpoint: FETCH_DONATION_SUMMARY,
});


export const fetchCountryDonationSummary = (id) => createApiService({
  endpoint: `${FETCH_COUNTRY_SUMMARY}${id}`,

})